import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";

/**
 * Fila del roster con control de asistencia de 3 estados:
 * Presente (true) / Ausente (false) / Sin marcar (null).
 *
 * "Ausente" no es lo mismo que "sin marcar": marca explícitamente una
 * inasistencia, que pasado el cupo del paquete descuenta horas al estudiante
 * (AttendancePage pide confirmación antes de enviarlo).
 */
function StudentRosterRow({ entry, onSetStatus, isLoading }) {
  const student = entry.student ?? entry;
  const st = entry.attendance_status;

  return (
    <div
      className="d-flex align-items-center justify-content-between py-2 border-bottom gap-2 flex-wrap"
      style={{ minHeight: 56 }}
    >
      <div>
        <span className="fw-medium">{student.name}</span>
        {st === true && (
          <span className="ms-2 badge bg-success-subtle text-success small">Presente</span>
        )}
        {st === false && (
          <span className="ms-2 badge bg-danger-subtle text-danger small">Ausente</span>
        )}
        {st === null && (
          <span className="ms-2 badge bg-light text-muted small">Sin marcar</span>
        )}
      </div>
      <ButtonGroup size="sm" aria-label={`Asistencia de ${student.name}`}>
        <Button
          variant={st === true ? "success" : "outline-secondary"}
          onClick={() => onSetStatus(entry, true)}
          disabled={isLoading}
          style={{ minHeight: 44 }}
        >
          ✓ Presente
        </Button>
        <Button
          variant={st === false ? "danger" : "outline-secondary"}
          onClick={() => onSetStatus(entry, false)}
          disabled={isLoading}
          style={{ minHeight: 44 }}
        >
          Ausente
        </Button>
        {st !== null && (
          <Button
            variant="outline-secondary"
            onClick={() => onSetStatus(entry, null)}
            disabled={isLoading}
            style={{ minHeight: 44 }}
            title="Volver a sin marcar"
          >
            ✕
          </Button>
        )}
      </ButtonGroup>
    </div>
  );
}

export { StudentRosterRow };
